import { render, staticRenderFns } from "./SpeedTest.vue?vue&type=template&id=0cb04e05&scoped=true"
import script from "./SpeedTest.vue?vue&type=script&lang=js"
export * from "./SpeedTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb04e05",
  null
  
)

export default component.exports